// @flow
import React from 'react';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import CustomModal from '../../../../elements/CustomModal/CustomModal';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../assets/styles/colors';
import type {Currency} from '../../../../entities';
import {commaFormat} from '../../../../utils/number';

type Props = {|
  open: boolean,
  bulkPrices?: {
    minQuantity: number,
    unitPrice: string,
  }[],
  currency?: Currency,
  handleClose: () => void,
  handleConfirm: () => void,
|};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyItems: 'center',
    alignItems: 'center',
    textAlign: 'center',
    maxWidth: 400,
    // height: 240,
    padding: theme.spacing(2, 0),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 'unset',
    },
  },
  title: {
    fontWeight: 600,
    fontSize: '1.375rem',
    lineHeight: '26px',
  },
  content: {
    margin: theme.spacing(5, 0),
  },
  text: {
    color: colors.grey700,
  },
  buttonContainer: {
    marginTop: theme.spacing(2),
  },
  tableContainer: {
    // width: '100%',
    background: colors.grey200,
    padding: 16,
    marginTop: theme.spacing(4),
    borderRadius: '12px',
  },
  table: {
    borderRadius: '12px',
    // marginTop: theme.spacing(2),
    borderCollapse: 'collapse',
    background: 'white',
    width: '100%',
  },
  th: {
    padding: '8px 16px',
    textAlign: 'left',
    fontWeight: 500,
  },
  td: {
    padding: '8px 16px',
    textAlign: 'left',
    fontWeight: 500,
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    height: 48,
    padding: '6px 26px',
    fontSize: '1.125rem',
    fontWeight: 600,
  },
}));

export default function VariantBulkPriceAlertModal(props: Props) {
  const {open, bulkPrices, currency, handleClose, handleConfirm} = props;

  const classes = useStyles();

  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <div className={classes.root}>
        <Typography gutterBottom className={classes.title}>
          ¿Está seguro que desea activar precios al por mayor?
        </Typography>
        <div className={classes.content}>
          <Typography className={classes.text}>
            Recuerde que el precio al por mayor debe ser el mismo para todas las
            variantes. Puede editarlo en la parte superior de precios al por
            mayor. <br />
            <br /> En caso quieras optar por precios diferentes por favor
            crearlo como un producto nuevo
          </Typography>
          <div className={classes.tableContainer}>
            <table className={classes.table}>
              <thead>
                <tr>
                  <th className={classes.th}>Cantidad</th>
                  <th className={classes.th}>Precio por producto</th>
                </tr>
              </thead>
              <tbody>
                {bulkPrices &&
                  bulkPrices.map((element, index) => (
                    <tr key={index}>
                      <td className={classes.td}>
                        A partir de {element.minQuantity} unidades
                      </td>
                      <td className={classes.td}>
                        {commaFormat(
                          element.unitPrice,
                          currency ? currency.symbol : ''
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className={classes.buttonRow}>
          <CustomButton
            variant="text"
            className={classes.button}
            color="primary"
            onClick={handleClose}
          >
            Cancelar
          </CustomButton>
          <CustomButton
            variant="contained"
            className={classes.button}
            color="primary"
            onClick={() => {
              handleConfirm();
              handleClose();
            }}
          >
            Confirmar
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
}
